export default "__VITE_ASSET__qGfwcsYV__"